// @flow

import React, { Component } from "react";

//redux
import { Provider } from "react-redux";
import Store from "./store";
import PageRoute from "./PageRoute";

class App extends Component<*> {

  componentDidMount() {
    const metaTag = document.querySelector("meta[name=\"build-tag\"]");
    if (metaTag) {
      metaTag.setAttribute("content", process.env.REACT_APP_BUILD_TAG);
    }
  }
  
  render(): React$Element<*> {
    return (
      <Provider store={Store}>
        <PageRoute />
      </Provider>
    );
  }
}

export default App;
